var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteGarbageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.37 8.91016L19.37 10.6402L7.24 3.64016L8.24 1.91016L11.28 3.66016L12.64 3.29016L16.97 5.79016L17.34 7.16016L20.37 8.91016ZM6 19.0002V7.00016H11.07L18 11.0002V19.0002C18 19.5306 17.7893 20.0393 17.4142 20.4144C17.0391 20.7894 16.5304 21.0002 16 21.0002H8C7.46957 21.0002 6.96086 20.7894 6.58579 20.4144C6.21071 20.0393 6 19.5306 6 19.0002Z",
    className: "fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteGarbageIcon);
export default __webpack_public_path__ + "static/media/delete-garbage-icon.db66fac9.svg";
export { ForwardRef as ReactComponent };